import PropTypes from 'prop-types';
import React from 'react';

import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';

import styles from 'styles/input.scss';
import S from './styles.scss';

const pasteSplit = data =>
  data.split(/[ ,]+/).map(d => d.trim());

const TaggedInput = ({ label, id, values, onChange, placeholder, errors }) => {
  const errorMsg = errors.join(', ');
  const wrapperStyles = errorMsg ? `${S.wrapper} ${styles.errored}` : S.wrapper;
  const labelStyles = errorMsg ? `${S.label} ${S.errorLabel}` : S.label;
  const inputStyles = `${styles.inputElement} ${S.element}`;

  const errStyles = `${styles.error} ${S.error}`;

  return (
    <div className={wrapperStyles}>
      <label className={labelStyles} htmlFor={id}>{label}</label>

      <TagsInput
        onlyUnique
        id={id}
        value={values}
        onChange={onChange}
        addOnPaste
        pasteSplit={pasteSplit}
        className={inputStyles}
        focusedClassName={styles.inputElement}
        tagProps={{ className: S.tag, classNameRemove: 'react-tagsinput-remove' }}
        inputProps={{ placeholder, className: S.input }}
        validationRegex={/^[^\s]+(\s+[^\s]+)*$/}
      />

      {errorMsg &&
        <div className={errStyles}><p className={S.errorMsg}>{errorMsg}</p></div>}
    </div>
  );
};

TaggedInput.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  errors: PropTypes.array.isRequired,
};

TaggedInput.defaultProps = {
  label: '',
  id: '',
  values: [],
  errors: [],
  placeholder: '',
};

export default TaggedInput;



// WEBPACK FOOTER //
// ./client/app/shared/components/TaggedInput/index.jsx